export const scrollToTop = (behavior: ScrollBehavior | undefined = "smooth") => {
  window.scroll({ top: 0, behavior });
};
